<template>
  <div class="st-bo-status">
    <dot
      :class="{ 'st-bo-status__dot--neutral': neutral }"
      :color="neutral ? '#FFFFFF' : color"
    />
    <span>{{ title }}</span>
  </div>
</template>
<script>
import Dot from "@/components/common/Dot.vue";

export default {
  name: "st-bo-status",
  components: {
    Dot,
  },
  props: {
    status: Boolean,
    pending: Boolean,
    neutral: Boolean,
    title: String,
  },
  computed: {
    color() {
      return this.pending ? "#f7bb0d" : this.status ? "#509E2F" : "#cc4039";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";

.st-bo-status {
  padding-right: rem-calc(16);

  &__dot--neutral {
    background-color: var(--background-color-secondary);
    border: rem-calc(1) solid var(--disabled-color-secondary);
    border-radius: 50%;
    box-sizing: border-box;
  }

  & > :not(:last-child) {
    margin-right: rem-calc(5);
  }
}
</style>
